import { Routes } from '@angular/router';
import * as RoutingMap from '@config/routing-map';
import { TournamentGameStatisticComponent } from './tournament-game-statistic/tournament-game-statistic.component';
import { TournamentGameComponent } from './tournament-game.component';
import { TournamentGameResolver } from './tournament-game.resolver';
import { TournamentGameProtocolComponent } from './tournament-game-protocol/tournament-game-protocol.component';
import { TournamentGameTimelineComponent } from './tournament-game-timeline/tournament-game-timeline.component';
import { TournamentGameStatisticResolver } from './tournament-game-statistic/tournament-game-statistic.resolver';
import { TournamentGameProtocolResolver } from './tournament-game-protocol/tournament-game-protocol.resolver';
import { TournamentGameTimelineResolver } from './tournament-game-timeline/tournament-game-timeline.resolver';
import { TournamentGameMediaComponent } from './tournament-game-media/tournament-game-media.component';
import { TournamentGameMediaResolver } from './tournament-game-media/tournament-game-media.resolver';
import { DialogPageComponent } from '@mtgame/ui';
import { TournamentGameMediaDialogComponent } from './tournament-game-media/tournament-game-media-dialog.component';
import { getGameMediaRoute, getGameRoute } from '@config/routes';
import { TournamentGameLiveComponent } from './tournament-game-live/tournament-game-live.component';
import { TournamentGameLiveResolver } from './tournament-game-live/tournament-game-live.resolver';

export const ROUTES: Routes = [
  {
    path: '',
    component: TournamentGameComponent,
    resolve: {
      game: TournamentGameResolver
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: RoutingMap.ROUTE_GAME_STATISTIC_ROOT
      },
      {
        path: RoutingMap.ROUTE_GAME_STATISTIC_ROOT,
        component: TournamentGameStatisticComponent,
        resolve: {
          data: TournamentGameStatisticResolver
        }
      },
      {
        path: RoutingMap.ROUTE_GAME_PROTOCOL_ROOT,
        component: TournamentGameProtocolComponent,
        resolve: {
          data: TournamentGameProtocolResolver
        }
      },
      {
        path: RoutingMap.ROUTE_GAME_TIMELINE_ROOT,
        component: TournamentGameTimelineComponent,
        resolve: {
          data: TournamentGameTimelineResolver
        }
      },
      {
        path: RoutingMap.ROUTE_GAME_MEDIA_ROOT,
        component: TournamentGameMediaComponent,
        resolve: {
          data: TournamentGameMediaResolver
        },
        children: [
          {
            path: ':mediaId',
            component: DialogPageComponent,
            data: {
              component: TournamentGameMediaDialogComponent,
              config: {
                closeLink: getGameMediaRoute().join('/'),
                isCloseButtonVisible: true,
                fullScreen: true
              }
            }
          }
        ]
      },
      {
        path: RoutingMap.ROUTE_GAME_LIVE,
        component: TournamentGameLiveComponent,
        resolve: {
          data: TournamentGameLiveResolver
        }
      }
    ]
  }
];
